import { createSelector } from 'reselect';

const uiSelector = state => state.ui;
const routingSelector = state => state.routing;
const userPermissionsSelector = state => state.ustate.perms;

export default createSelector(
	[uiSelector,routingSelector,userPermissionsSelector],
	(ui,routing,userPermissions) => {
		return {
			sidebarOpened: ui.sidebarOpened,
			searchBarOpened: ui.searchBarOpened,
			headerOverflowOpened: ui.headerOverflowOpened,
			loginModalOpened: ui.loginModalOpened,
			confirmModalOpened: ui.confirmModalOpened,
			confirmModalOptions: ui.confirmModalOptions,
			globalLoading: ui.globalLoading,
			replyModalOpened: ui.replyModal.opened,
			userModalOpened: ui.userModal.opened,
			shareModalOpened: ui.shareModal.opened,
			iOSkeyBoardOpen: ui.iOSkeyBoardOpen,
			announcementsOpen: ui.announcementsOpen,
			userPermissions,
			routing
		};
	}
);



// WEBPACK FOOTER //
// ./src/selectors/uiSelectors.js